export default {
    colorPrimary: '#29374A',
    accentPrimary: '#d2b690'
};
